import {
  FETCH_DEPARTMENTS_LIST,
  FETCH_DEPARTMENT_BY_ID,
  ADD_DEPARTMENT,
  UPDATE_DEPARTMENT,
  DELETE_DEPARTMENT,
  SET_DEPARTMENT_LOADING,
  SET_DEPARTMENT_ERROR,
  CLEAR_DEPARTMENT_ERROR,
  FETCH_SPECIALITIES_LIST,
} from "../actions/type";

const initialState = {
  departments: [],
  pagination: {
    currentPage: 1,
    totalPages: 0,
    totalRecords: 0,
    pageSize: 10,
  },
  selectedDepartment: null,
  specialities: [],
  loading: false,
  specialityLoading: false,
  error: null,
  specialityError: null,
};

const normalizeDepartmentsPayload = (payload) => {
  if (Array.isArray(payload)) {
    return {
      departments: payload,
      pagination: initialState.pagination,
    };
  }

  const departments =
    payload?.departments ||
    payload?.departmentList ||
    payload?.departmentsList ||
    payload?.departmentlist ||
    payload?.items ||
    payload?.results ||
    payload?.data ||
    payload?.records ||
    [];

  const pageSize =
    payload?.pageSize ??
    payload?.limit ??
    payload?.pagecount ??
    initialState.pagination.pageSize;

  const totalPages =
    payload?.totalPages ??
    payload?.pages ??
    payload?.totalNumberOfPages ??
    payload?.totalPageCount ??
    initialState.pagination.totalPages;

  const totalRecords =
    payload?.totalRecords ??
    payload?.total ??
    payload?.count ??
    payload?.totalNumberOfRecords ??
    payload?.totalCount ??
    (totalPages > 0 ? totalPages * pageSize : initialState.pagination.totalRecords);

  return {
    departments: Array.isArray(departments) ? departments : [],
    pagination: {
      currentPage:
        payload?.currentPage ??
        payload?.page ??
        payload?.pageNumber ??
        payload?.pageNo ??
        initialState.pagination.currentPage,
      totalPages,
      totalRecords,
      pageSize,
    },
  };
};

const departmentManagementReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_DEPARTMENTS_LIST: {
      const { departments, pagination } = normalizeDepartmentsPayload(action.payload);

      return {
        ...state,
        departments,
        pagination,
      };
    }

    case FETCH_DEPARTMENT_BY_ID:
      return {
        ...state,
        selectedDepartment: action.payload || null,
      };

    case ADD_DEPARTMENT:
      return {
        ...state,
        departments: action.payload
          ? [action.payload, ...state.departments]
          : state.departments,
      };

    case UPDATE_DEPARTMENT:
      return {
        ...state,
        departments: state.departments.map((department) =>
          department.ssm_id === action.payload?.ssm_id ? action.payload : department
        ),
        selectedDepartment:
          state.selectedDepartment?.ssm_id === action.payload?.ssm_id
            ? action.payload
            : state.selectedDepartment,
      };

    case DELETE_DEPARTMENT:
      return {
        ...state,
        departments: state.departments.filter(
          (department) => department.ssm_id !== action.payload
        ),
        selectedDepartment:
          state.selectedDepartment?.ssm_id === action.payload
            ? null
            : state.selectedDepartment,
      };

    case FETCH_SPECIALITIES_LIST:
      return {
        ...state,
        specialities: Array.isArray(action.payload) ? action.payload : [],
        specialityError: null,
      };

    case SET_DEPARTMENT_LOADING:
      return {
        ...state,
        loading: Boolean(action.payload),
        specialityLoading: Boolean(action.payload),
      };

    case SET_DEPARTMENT_ERROR:
      return {
        ...state,
        error: action.payload || "Something went wrong",
        specialityError: action.payload || "Something went wrong",
      };

    case CLEAR_DEPARTMENT_ERROR:
      return {
        ...state,
        error: null,
        specialityError: null,
      };

    default:
      return state;
  }
};

export default departmentManagementReducer;
